module.exports = __webpack_public_path__ + "img/93967.91735360.svg";